<external>
  <ng-container content>
	  <div class="page-not-found">
      <div class="number">404</div>
      <div class="text">Oops! The page you have requested is not found!</div>
    </div>
  </ng-container>
</external>